import React from 'react';
import Input from '../../../components/ui/input';
import Label from '../../../components/ui/label';
import { EXPENSE_CATEGORIES } from '../shared/constants';

const ExpenseFilters = ({ filters, onUpdate }) => {
	const handleSearchChange = (value) => {
		onUpdate({ search: value });
	};

	const handleCategoryToggle = (category) => {
		const newCategories = filters.categories.includes(category)
			? filters.categories.filter((c) => c !== category)
			: [...filters.categories, category];
		onUpdate({ categories: newCategories });
	};

	const handleDateRangeChange = (field, value) => {
		onUpdate({
			dateRange: {
				...filters.dateRange,
				[field]: value,
			},
		});
	};

	const handleAmountRangeChange = (field, value) => {
		onUpdate({
			amountRange: {
				...filters.amountRange,
				[field]: value === '' ? (field === 'min' ? 0 : Infinity) : parseFloat(value),
			},
		});
	};

	const clearFilters = () => {
		onUpdate({
			search: '',
			categories: [],
			dateRange: { start: '', end: '' },
			amountRange: { min: 0, max: Infinity },
		});
	};

	return (
		<div className='space-y-4'>
			<div className='flex items-center justify-between'>
				<h4 className='text-sm font-montserrat-medium text-clientBlack'>
					Filters
				</h4>
				<button
					onClick={clearFilters}
					className='text-sm text-primary hover:text-primary/80 font-montserrat'>
					Clear all
				</button>
			</div>

			{/* Search */}
			<div>
				<Label className='text-sm font-montserrat-medium'>
					Search in name/notes
				</Label>
				<Input
					type='text'
					value={filters.search}
					onChange={(e) => handleSearchChange(e.target.value)}
					placeholder='Search expenses...'
					className='mt-1 font-montserrat'
				/>
			</div>

			{/* Category Filter */}
			<div>
				<Label className='text-sm font-montserrat-medium mb-2 block'>
					Categories
				</Label>
				<div className='grid grid-cols-2 gap-2'>
					{EXPENSE_CATEGORIES.map((category) => (
						<label
							key={category}
							className='flex items-center gap-2 cursor-pointer'>
							<input
								type='checkbox'
								checked={filters.categories.includes(category)}
								onChange={() => handleCategoryToggle(category)}
								className='rounded border-gray-300 text-primary focus:ring-primary'
							/>
							<span className='text-sm font-montserrat'>{category}</span>
						</label>
					))}
				</div>
			</div>

			{/* Date Range */}
			<div>
				<Label className='text-sm font-montserrat-medium mb-2 block'>
					Date Range
				</Label>
				<div className='grid grid-cols-2 gap-3'>
					<div>
						<Label className='text-xs font-montserrat text-gray-600'>
							From
						</Label>
						<Input
							type='date'
							value={filters.dateRange.start}
							onChange={(e) => handleDateRangeChange('start', e.target.value)}
							className='mt-1 font-montserrat'
						/>
					</div>
					<div>
						<Label className='text-xs font-montserrat text-gray-600'>To</Label>
						<Input
							type='date'
							value={filters.dateRange.end}
							onChange={(e) => handleDateRangeChange('end', e.target.value)}
							className='mt-1 font-montserrat'
						/>
					</div>
				</div>
			</div>

			{/* Amount Range */}
			<div>
				<Label className='text-sm font-montserrat-medium mb-2 block'>
					Amount Range
				</Label>
				<div className='grid grid-cols-2 gap-3'>
					<div>
						<Label className='text-xs font-montserrat text-gray-600'>
							Min ($)
						</Label>
						<Input
							type='number'
							step='0.01'
							value={filters.amountRange.min || ''}
							onChange={(e) => handleAmountRangeChange('min', e.target.value)}
							placeholder='0.00'
							className='mt-1 font-montserrat'
						/>
					</div>
					<div>
						<Label className='text-xs font-montserrat text-gray-600'>
							Max ($)
						</Label>
						<Input
							type='number'
							step='0.01'
							value={
								filters.amountRange.max === Infinity
									? ''
									: filters.amountRange.max
							}
							onChange={(e) => handleAmountRangeChange('max', e.target.value)}
							placeholder='Unlimited'
							className='mt-1 font-montserrat'
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExpenseFilters;
